// link abis

const HANDLER_ABI = require('../../../smart-contract/SoftwareHandler_abi.json');
const SOFTWARE_ABI = require('../../../smart-contract/Software_abi.json');
const LICENSE_ABI = require('../../../smart-contract/license_abi.json');
const UTILS_ABI = require('../../../smart-contract/Utils_abi.json');

module.exports = {
	HANDLER_ABI,
	SOFTWARE_ABI,
	LICENSE_ABI,
	UTILS_ABI,
};
